module.exports = require("eventemitter3");


//////////////////
// WEBPACK FOOTER
// external "eventemitter3"
// module id = 14
// module chunks = 0